import { render, staticRenderFns } from "./activity-widget.vue?vue&type=template&id=2c8d85bc&scoped=true&"
import script from "./activity-widget.vue?vue&type=script&lang=js&"
export * from "./activity-widget.vue?vue&type=script&lang=js&"
import style0 from "./activity-widget.vue?vue&type=style&index=0&id=2c8d85bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d85bc",
  null
  
)

export default component.exports